<script lang="ts" setup>
import { Button } from '@forgd/ui-kit/button'

const { bannerVisible, accept, reject } = useCookieConsent()
</script>

<!-- Mounted inside app.vue's ClientOnly block — no SSR concern of its own -->
<template>
  <div
    v-if="bannerVisible"
    data-el="CoreCookieConsentBanner"
    class="fixed inset-x-0 bottom-0 z-[200] border-t border-default bg-page px-6 py-6 shadow-card"
  >
    <div class="mx-auto flex max-w-5xl flex-col gap-4 md:flex-row md:items-center">
      <p class="flex-1 text-sm leading-[21px] text-primal">
        We use cookies for analytics, error monitoring, and partner attribution. See our
        <a
          href="/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          class="font-semibold text-hyperlink hover:text-hyperlink-hover"
        >privacy policy</a>.
      </p>
      <div class="flex shrink-0 gap-3">
        <Button variant="outline" size="sm" data-testid="cookie-consent-reject" @click="reject">
          Reject
        </Button>
        <Button variant="outline" size="sm" data-testid="cookie-consent-accept" @click="accept">
          Accept
        </Button>
      </div>
    </div>
  </div>
</template>
